document.addEventListener('DOMContentLoaded', () => {
	const filter = document.getElementById('js-works-filter');
	const list = document.querySelector('.work-list');

	if (!filter || !list) return;

	const items = Array.from(list.querySelectorAll('.work-item'));

	const getChecked = (name) => Array.from(filter.querySelectorAll(`input[name="${name}"]:checked`)).map((el) => el.value);

	const applyFilter = () => {
		const itemSlugs = getChecked('item-category');
		const areaSlugs = getChecked('area-category');

		items.forEach((item) => {
			const itemData = (item.dataset.item || '').split(' ');
			const areaData = (item.dataset.area || '').split(' ');

			const matchItem = itemSlugs.length === 0 || itemSlugs.some((slug) => itemData.includes(slug));
			const matchArea = areaSlugs.length === 0 || areaSlugs.some((slug) => areaData.includes(slug));

			item.hidden = !(matchItem && matchArea);
		});
	};

	filter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
		checkbox.addEventListener('change', applyFilter);
	});
});
